module.exports = __webpack_public_path__ + "img/growcify-account-manager.66630414.png";